import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setSelectedFaculty, clearSelectedFaculty } from '../../store/slices/filtersSlice';
import { useEffect, useCallback } from 'react';

export const FacultyFilter = () => {
	const dispatch = useAppDispatch();
	const { faculties, selectedFaculty } = useAppSelector((state) => state.filters);
	const { user } = useAppSelector((state) => state.user);

	const isUserRole = user?.role === 'user';
	const userFacultyCode = user?.maKhoa || 'N/A';

	const handleFacultyChange = useCallback((value: string) => {
		if (value === '') {
			dispatch(clearSelectedFaculty());
		} else {
			dispatch(setSelectedFaculty(value));
		}
	}, [dispatch]);

	useEffect(() => {
		if (isUserRole && userFacultyCode !== 'N/A') {
			handleFacultyChange(userFacultyCode);
		}
	}, [isUserRole, userFacultyCode, handleFacultyChange]);

	return (
		<Box sx={{ p: 2 }}>
			<FormControl fullWidth size="small">
				<InputLabel>Khoa</InputLabel>
				<Select
					value={selectedFaculty || ''}
					onChange={(e) => handleFacultyChange(e.target.value)}
					label="Khoa"
					disabled={isUserRole}
				>
				<MenuItem value="">Tất cả khoa</MenuItem>
					{faculties?.map((faculty: { value: string; label: string }) => (
						<MenuItem key={faculty.value} value={faculty.value}>
							{faculty.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
};
